import { useEffect } from "react";
import { ShippingDetailsViewModel } from "../../viewmodels/shipping/ShippingDetailsViewModel";

import { useParams } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import CreateNewShippingForm from "../../components/forms/shipping/CreateNewShippingForm";

function formatCustomerHeading(customer) {
  if (customer == null || customer === "") return null;
  if (typeof customer === "string") return customer;
  if (typeof customer === "object") {
    return customer.name ?? customer.label ?? null;
  }
  return null;
}

function ShippingDetails(props) {
  const { addSnackbar, logout, user_type } = props;

  const { shippingId } = useParams();

  const {
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    emptyModal,
    showErrorModal,
    updateShippingApiCall,
    shipping,
    addPackagedItemToOrderItem,
    getShippingDetails,
    removeShippedCartonApiCall,
    employeeOptions,
    getEmployeesForDropdown,
    deleteShipping,
    printShipping,
    getOrderItemShipments,
    createShippingRecordByID,
    setProductTemperature,
    onFetchPackagedItemByBarcode,
    generateAndPrintShippingLabel,
  } = ShippingDetailsViewModel(shippingId, logout, addSnackbar);

  const apiFunctionCalls = async function () {
    let callResult = await getEmployeesForDropdown([1, 2], [1, 5]);
    if (callResult.success) {
      getShippingDetails();
    } else {
    }
  };

  useEffect(() => {
    apiFunctionCalls();
  }, []);

  const customerHeadingLine = shipping
    ? formatCustomerHeading(shipping.customer.label)
    : null;

  return (
    <div>
      <div className="mt-2 pl-0 sm:px-4">
        <div className="sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              Shipment PO #: {shipping?.po_number}
            </h1>
            {customerHeadingLine ? (
              <p className="mt-1 text-lg text-gray-600">
                {customerHeadingLine}
              </p>
            ) : null}
          </div>
          <div className="mt-5">
            {shipping ? (
              <CreateNewShippingForm
                setEmptyModelOpen={setEmptyModelOpen}
                showErrorModal={showErrorModal}
                updateShippingApiCall={updateShippingApiCall}
                shipping={shipping}
                onFetchPackagedItemByBarcode={onFetchPackagedItemByBarcode}
                addPackagedItemToOrderItem={addPackagedItemToOrderItem}
                removeShippedCartonApiCall={removeShippedCartonApiCall}
                employeeOptions={employeeOptions}
                deleteShipping={deleteShipping}
                printShipping={printShipping}
                getOrderItemShipments={getOrderItemShipments}
                createShippingRecordByID={createShippingRecordByID}
                setProductTemperature={setProductTemperature}
                user_type={user_type}
                generateAndPrintShippingLabel={generateAndPrintShippingLabel}
              />
            ) : null}
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass="max-w-3xl"
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user_type: state.auth.user_type,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShippingDetails),
);
